import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../../configs/AppConfig";
import {AUTH_TIPE} from "../../constants/AuthConstant";

const  unitKerjaService = {}

unitKerjaService.data = function (token,data='') {
    return fetch({
        url: '/ref/unit_kerja/data',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

unitKerjaService.show = function (token,data='') {
    return fetch({
        url: '/ref/unit_kerja/show',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

unitKerjaService.data_import = function (token,data) {
    return fetch({
        url: '/ref/unit_kerja/data_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

unitKerjaService.empty_import = function (token,data) {
    return fetch({
        url: '/ref/unit_kerja/empty_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

unitKerjaService.save_import = function (token,data) {
    return fetch({
        url: '/ref/unit_kerja/save_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

export default unitKerjaService;
